import dayjs from 'dayjs';
import useSWRMutation from 'swr/mutation';

import { currentTimeZone } from '../../../1_shared/constants/timeZone';
import { useAuthContext } from '../../../app/module/lib/hooks/useAuthContext';

import { addScheduleOnWeek } from './api/add.schedule.api';
import { IModalScheduleAdd } from './api/interfaces/IModalScheduleAdd';
import { TScheduleWeek } from '../config/schema';

const useAddScheduleOnWeek = () => {
  const { trigger } = useSWRMutation(
    '/ss/slots/v1/generate',
    addScheduleOnWeek,
  );
  const { user } = useAuthContext();

  const onAdd = async (data: TScheduleWeek) => {
    const tempData = {
      specialistId: String(user?.id),
      zoneOffset: currentTimeZone,
      ...data,
      dayStartAt: dayjs(data.dayStartAt).format('HH:mm'),
      dayEndAt: dayjs(data.dayEndAt).format('HH:mm'),
      breakStartAt: data.breakStartAt
        ? dayjs(data.breakStartAt).format('HH:mm')
        : null,
      breakEndAt: data.breakStartAt
        ? dayjs(data.breakEndAt).format('HH:mm')
        : null,
    };

    return await trigger(tempData as IModalScheduleAdd);
  };

  return { onAdd };
};

export default useAddScheduleOnWeek;
